import { useEffect, useState } from 'react';
import { socket } from '../socket';
import { getData } from 'utilities/common';

export default function useSocket() {
  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    const user = getData('login-user-info');

    // if (user && !socket.connected) {
    if (!socket.connected) {
      const parseUser = JSON.parse(user);
      const token = parseUser?.access_token;

      // if (token && !socket.connected) {
      // socket.auth = { token };
      socket.connect();
      // }
    }

    function onConnect() {
      setIsConnected(true);
      console.log("Socket is connected")
    }

    function onDisconnect() {
      setIsConnected(false);
      console.log("Socket is disconnected")
    }

    function onConnectError(err) {
      console.log('Socket connection error: --------->', err.message, err);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('connect_error', onConnectError);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('connect_error', onConnectError);
    };
  }, []);

  return { isConnected };
}